import React , {Component} from 'react'
import Flatpickr from 'react-flatpickr';
import './EventForm.css'
import {db} from './../firebase/firebase.js'
import {colors} from './../utils/constants.js'
import '../../node_modules/flatpickr/dist/themes/material_blue.css'
import toast from '../utils/toast.js'
import firebase from 'firebase'
import geo from 'html5-geolocation'

class EventForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            tags: new Set(),
            eventStart: new Date(new Date().getTime() - 30*1000*60),
            eventEnd: new Date(new Date().getTime() + 30*1000*60),
            location : [0,0],
            userId: "uG17J2iQ8COsRnU66n8HNbWYp4p1" // for mindi to implement
          };
        geo().on('position', (position) => {

            this.setState({location: [position.coords.latitude, position.coords.longitude]})
        })
        .on('error', (error) => {
            // this.setState({})
        })
        .highAccuracy(true)
        .watch()

        
          this.handleInputChange = this.handleInputChange.bind(this);
          this.handleStartDateChange = this.handleStartDateChange.bind(this);
          this.handleEndDateChange = this.handleEndDateChange.bind(this);
          this.handleSubmit = this.handleSubmit.bind(this);
      
    }    
    handleClick(id, event) {
        // event.preventDefault();
        let type = id.substr(5)

        if (this.state.tags && this.state.tags.has(id)) { // if clicked already
          // unclick
         console.log(type)
            document.getElementById(`${type}Square`).style.color = colors.indigo;
            document.getElementById(`${type}Icon`).style.color = colors.white;
            this.state.tags.delete(id)
        } else {
            this.state.tags.add(id)
            // click it (style)
            console.log(colors)
            document.getElementById(`${type}Square`).style.color = colors.powderBlue;
            document.getElementById(`${type}Icon`).style.color = colors.indigo
        
        }
        console.log(this.state.tags)
    
      }
    
      handleSubmit(event){
        if (this.state.tags.size === 0) {
          toast("Select What Is Happening!")
          return
        }
        toast("Creating Object", 3000)
        event.preventDefault();
        let state = this.state
        state.tags = Array.from(state.tags)
        state.datePosted = new Date()
        state.location = new firebase.firestore.GeoPoint(state.location[0], state.location[1])
        console.log(state)
        db.collection("events")
          .add(this.state).
          then((ref) => {
            console.log(`Ref id: ${ref.id}`)
            toast("Success!")
          })
      }
    
    
      handleInputChange(event) {
        const target = event.target;
        const type = target.type;
        switch(type){
          case "select":
            const value = target.value;
            const name = target.name;
            this.setState({
              [name]: value
            });
            break;
        }
      }
    
      handleStartDateChange(date) { this.setState({ startDate: date }) }
      handleEndDateChange(date) { this.setState({ endDate: date }) }
    
    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className = "EventForm">
                    <div className = "tableMain" style={{backgroundColor:colors.lightIndigo}}>
                        <div className = "typeButtonContainer">
                        <a  onClick={this.handleClick.bind(this, "#freeFood")} style={{textDecoration:"none"}}>
                            <span className="fa-stack fa-lg coolmoji">
                                <i id="FoodSquare" className="fa fa-square fa-stack-2x" style = {{color:colors.indigo}}></i>
                                <i id="FoodIcon" className="fa fa-cutlery fa-stack-1x fa-inverse" ></i>
                            </span>  
                        </a>
                        <a  onClick={this.handleClick.bind(this, "#freeMusic")} style={{textDecoration:"none"}}>
                            <span className="fa-stack fa-lg coolmoji">
                                <i id="MusicSquare" className="fa fa-square fa-stack-2x" style = {{color:colors.indigo}}></i>
                                <i id="MusicIcon" className="fa fa-music fa-stack-1x fa-inverse"></i>
                            </span>  
                        </a>
                        <a  onClick={this.handleClick.bind(this, "#freeSwag")} style={{textDecoration:"none"}}>
                            <span className="fa-stack fa-lg coolmoji">
                                <i id="SwagSquare" className="fa fa-square fa-stack-2x" style = {{color:colors.indigo}}></i>
                                <i id="SwagIcon" className="fa fa-shopping-bag fa-stack-1x fa-inverse"></i>
                            </span>  
                        </a>        
                        </div>
                        <div className = "locationField">
                            Where's the event?
                        <input type = "text" value="Current Location" className = "locInput"></input>
                        
                        <br></br><br></br>
                        What's the time?
                        </div>
                        <div className = "timeFieldContainer">

      <Flatpickr data-enable-time
        value={this.state.eventStart}
        className='buttonstyle'
        onChange={this.handleStartChange}
        style={{width:100,height:50}}
      />
      <Flatpickr data-enable-time
        value={this.state.eventEnd}
        onChange={this.handleEndChange}
        className='buttonstyle'
        title={"Event End Date"}
        style={{width:100,height:50}}
      />
                        </div>
                        <div className = "postButtonContainer">
                            <button onClick={this.handleSubmit} type = "button" className = "postButton">
                            POST
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

export default EventForm
